import { useState } from 'react';
import { Button } from '../../components';
import type { AmoyeApi, ReviewedInvoiceFactsInput } from '../../lib/api';
import { BusinessInvoiceInteraction, type BusinessInvoiceInteractionProps } from '../track-b1';

export function createPracticeInvoiceDraft(api: Pick<AmoyeApi, 'createInvoiceFromReviewedFacts'>,
  taxpayerId: string, facts: ReviewedInvoiceFactsInput) {
  return api.createInvoiceFromReviewedFacts({ track: 'A', taxpayerId, facts });
}

export function PracticeInvoiceWorkflow(props: BusinessInvoiceInteractionProps) {
  const [open, setOpen] = useState(false);
  return <section className="am-a-invoice-workflow">
    <div className="am-a-maker-checker" role="note">
      <strong>Selected-client invoice responsibility</strong>
      <p>You may create and prepare this client’s invoice draft. A different authorised practitioner must review and approve it, and a separately authorised submitter must start delivery.</p>
    </div>
    {!open ? <Button onClick={() => setOpen(true)} tone="secondary">Create e-invoice for selected client</Button>
      : <BusinessInvoiceInteraction {...props} />}
  </section>;
}
